import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { StarIcon, SaveIcon, CheckCircleIcon } from 'lucide-react';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { MOCK_POINTS_SETTINGS } from '../../lib/mockData';
export function PointsRulesPage() {
  const [settings, setSettings] = useState({
    ...MOCK_POINTS_SETTINGS
  });
  const [saved, setSaved] = useState(false);
  const handleSave = () => {
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  };
  const update = (key: string, value: number | boolean) => {
    setSettings(prev => ({
      ...prev,
      [key]: value
    }));
  };
  return <div data-id="element-863">
      <motion.div initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} data-id="element-864">
        <h1 className="text-2xl font-bold text-white mb-1 flex items-center gap-3" data-id="element-865">
          <StarIcon className="w-7 h-7 text-[#C8A84E]" data-id="element-866" />
          Cài Đặt Điểm Thưởng
        </h1>
        <p className="text-sm text-[#666666] mb-6" data-id="element-867">
          Quản lý quy tắc tích điểm và đổi thưởng
        </p>
      </motion.div>

      {saved && <motion.div initial={{
      opacity: 0,
      y: -10
    }} animate={{
      opacity: 1,
      y: 0
    }} className="mb-4 bg-[#22C55E]/10 border border-[#22C55E]/20 rounded-xl p-3 flex items-center gap-2" data-id="element-868">
          <CheckCircleIcon className="w-4 h-4 text-[#22C55E]" data-id="element-869" />
          <span className="text-sm text-[#22C55E]" data-id="element-870">Đã lưu cài đặt!</span>
        </motion.div>}

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-871">
        <Card title="Quy Tắc Tích Điểm" data-id="element-872">
          <div className="space-y-4" data-id="element-873">
            <Input label="VNĐ cho mỗi điểm" type="number" value={settings.vndPerPoint.toString()} onChange={e => update('vndPerPoint', parseInt(e.target.value) || 0)} hint={`Mỗi ${settings.vndPerPoint.toLocaleString('vi-VN')}đ chi tiêu = 1 điểm`} data-id="element-874" />
            <Input label="Hệ số mặc định" type="number" value={settings.defaultMultiplier.toString()} onChange={e => update('defaultMultiplier', parseFloat(e.target.value) || 0)} hint="Hệ số nhân điểm mặc định (1 = bình thường)" data-id="element-875" />
          </div>
        </Card>

        <Card title="Quy Tắc Đổi Thưởng" data-id="element-876">
          <div className="space-y-4" data-id="element-877">
            <div data-id="element-878">
              <label className="block text-sm font-medium text-[#B0B0B0] mb-1.5" data-id="element-879">
                Cho phép đổi thưởng
              </label>
              <button onClick={() => update('redemptionEnabled', !settings.redemptionEnabled)} className={`flex items-center gap-3 w-full p-3 rounded-lg border transition-colors ${settings.redemptionEnabled ? 'border-[#C8A84E] bg-[#C8A84E]/10' : 'border-[#2A2A2A]'}`} data-id="element-880">
                <div className={`w-10 h-6 rounded-full transition-colors ${settings.redemptionEnabled ? 'bg-[#C8A84E]' : 'bg-[#2A2A2A]'}`} data-id="element-881">
                  <div className={`w-5 h-5 bg-white rounded-full mt-0.5 transition-transform ${settings.redemptionEnabled ? 'ml-[18px]' : 'ml-0.5'}`} data-id="element-882" />
                </div>
                <span className="text-sm text-white" data-id="element-883">
                  {settings.redemptionEnabled ? 'Bật' : 'Tắt'}
                </span>
              </button>
            </div>
            <Input label="Điểm cho mỗi đơn vị đổi" type="number" value={settings.pointsPerRedemptionUnit.toString()} onChange={e => update('pointsPerRedemptionUnit', parseInt(e.target.value) || 0)} data-id="element-884" />
            <Input label="Giá trị mỗi đơn vị đổi (VNĐ)" type="number" value={settings.redemptionUnitValueVnd.toString()} onChange={e => update('redemptionUnitValueVnd', parseInt(e.target.value) || 0)} hint={`${settings.pointsPerRedemptionUnit} điểm = ${settings.redemptionUnitValueVnd.toLocaleString('vi-VN')}đ`} data-id="element-885" />
          </div>
        </Card>
      </div>

      <div className="mt-6 flex justify-end" data-id="element-886">
        <Button onClick={handleSave} data-id="element-887">
          <SaveIcon className="w-4 h-4" data-id="element-888" />
          Lưu Cài Đặt
        </Button>
      </div>
    </div>;
}